<!-- @format -->

<template>
  <div>

    <b-modal id="Acci-Details-Modal" title="Accident Details" title-class="font-18" hide-footer no-close-on-backdrop
      size="xl">
      <template #modal-header>
        <div class="d-flex justify-content-between w-100">
          <h5>Accident Details</h5>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('Acci-Details-Modal')">
            Cancel
          </button>
        </div>
      </template>
      <div class="card">
        <div class="card-body row p-2">
          <div class="col-6">
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Accident Id</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.id" Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Source</p>
              </div>
              <div class="col-8">
                <!-- <input class="form-control inp-bg" v-model="editAccidentDetailsObj.source_name" /> -->
                <select class="form-control inp-bg w-100" v-model="editAccidentDetailsObj.source_id">
                  <option value="1">1033</option>
                  <option value="2">Caller</option>
                  <option value="3">TMCS</option>
                  <option value="4">Police</option>
                  <option value="5">Staff</option>
                  <option value="6">RPV</option>
                  <option value="7">VIDS/VSDS</option>
                </select>
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Chainage Number</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.ch_no" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Side</p>
              </div>
              <div class="col-8">
                <!-- <input class="form-control inp-bg" v-model="editAccidentDetailsObj.side" /> -->
                <select class="form-control inp-bg w-100" v-model="editAccidentDetailsObj.side">
                  <option value="LHS">LHS</option>
                  <option value="RHS">RHS</option>
                </select>
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Vehicle Involved</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.vehicle_involved" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Accident Date/Time</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.incident_datetime" Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Reported Date/Time</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.reported_datetime" Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Close Date/Time</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.close_datetime" Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Assigned To</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.reported_to_name" />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Nature of Accident</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.nature_of_accident" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Reason of Accident</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.reason_of_accident" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Nature of Injury</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.nature_of_injury" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Arrival Time Of RPV</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.arrival_time_of_rpv" Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Arrival Time Of Ambulance</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.arrival_time_of_ambulance"
                  Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Arrival Time Of Crane</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.arrival_time_of_crane" Disabled />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Description</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.description" />
              </div>
            </div>
            <div class="mb-3 d-flex">
              <div class="col-4">
                <p>Action Taken</p>
              </div>
              <div class="col-8">
                <input class="form-control inp-bg" v-model="editAccidentDetailsObj.action_taken" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-success btn-block" @click="saveAccidentDetails">
            <i class="fas fa-check"></i> Save
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    editAccidentObj: Object,
  },

  data() {
    return {
      selectedAccident: null,
      editAccidentDetailsObj: {
        id: "",
        source_id: "",
        ch_no: "",
        side: "",
        vehicle_involved: "",
        incident_datetime: "",
        reported_datetime: "",
        close_datetime: "",
        reported_to_name: "",
        nature_of_accident: "",
        reason_of_accident: "",
        nature_of_injury: "",
        arrival_time_of_rpv: "",
        arrival_time_of_ambulance: "",
        arrival_time_of_crane: "",
        description: "",
        action_taken: "",
      },
    };
  },

  watch: {
    editAccidentObj() {
      this.editAccidentDetailsObj = JSON.parse(JSON.stringify(this.editAccidentObj));
    },
  },

  methods: {

    saveAccidentDetails() {
      console.log("submit button clicked");
      console.log(this.editAccidentDetailsObj);



      axios.put(`http://localhost:3001/api/incidents/update-accident/${this.editAccidentDetailsObj.id}`, this.editAccidentDetailsObj)
        .then(response => {
          this.selectedAccident = this.editAccidentDetailsObj;
          this.$bvModal.hide("Acci-Details-Modal");

          Swal.fire("Success", "Accident details updated successfully", "success")
            .then(() => {
              this.$emit('reload')
            })
        })
        .catch(error => {
          console.error(error);
          Swal.fire("Error", "There was a problem updating the accident details", "error");
        });
    },
  },
};
</script>

<style scoped>
.inp-bg {
  background-color: #5c6b7a;
}
</style>
